module.exports = __webpack_public_path__ + "static/media/richariche_cellulari.e18b6911.png";